<template>
  <div>
    <input-select-validated
      :value="value.recipeId"
      :label="$t('components.materialTemplate.createModal.recipe')"
      :options="recipeOptions"
      rules="required"
      @input="selectRecipe"
    />
    <a
      v-if="authoringUrl"
      class="mt-2 inline-block text-sm text-blue-600 hover:underline"
      :href="authoringUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ $t('components.materialTemplate.createModal.openRecipeAuthoring') }}
    </a>
  </div>
</template>

<script>
import InputSelectValidated from '@/components/form/select-validated'
import GET_MATERIAL_MAKER_GENERATION_RECIPES from '@/graphql/GetMaterialMakerGenerationRecipes.gql'

export default {
  components: { InputSelectValidated },
  props: {
    value: {
      type: Object,
      required: true
    },
    assetType: {
      type: String,
      default: 'GUIDE'
    }
  },
  data () {
    return {
      materialMakerGenerationRecipes: [],
      authoringUrl: process.env.VUE_APP_MATERIAL_MAKER_WEB || ''
    }
  },
  apollo: {
    materialMakerGenerationRecipes: {
      query: GET_MATERIAL_MAKER_GENERATION_RECIPES,
      variables () {
        return { type: this.recipeMaterialType }
      }
    }
  },
  computed: {
    recipeMaterialType () {
      if (this.assetType === 'FLYER') return 'FLYER'
      return ['SOCIAL_IMAGE', 'SOCIAL_STORY'].includes(this.assetType)
        ? 'SOCIAL_IMAGE'
        : 'GUIDE'
    },
    // A template pins one exact revision. A recipe with no approved revision
    // would submit an empty ID, which passes GraphQL and then fails the server
    // schema with no message the operator can act on.
    recipeOptions () {
      return this.materialMakerGenerationRecipes
        .filter(recipe => Boolean(recipe.approvedRevisionId))
        .map(recipe => ({
          value: recipe.id,
          name: `${recipe.title} (${recipe.locale.toUpperCase()})`
        }))
    }
  },
  watch: {
    recipeMaterialType () {
      this.$emit('input', { recipeId: '', recipeRevisionId: '' })
    }
  },
  methods: {
    selectRecipe (recipeId) {
      const recipe = this.materialMakerGenerationRecipes.find(item => item.id === recipeId)
      this.$emit('input', {
        recipeId,
        recipeRevisionId: recipe?.approvedRevisionId ?? ''
      })
    }
  }
}
</script>
